module.exports = __webpack_public_path__ + "img/strong_core_values.f9330a42.png";